export const EventNames = {
  BRAND_GUIDE_PAGE_VIEW: 'Brand Guide - Page View',
};